import styled from 'styled-components';
import { ItemList } from '../../ui/ItemCard/styled';

export const AgencyFilterContainer = styled.section`
  background-color: ${({ theme }) => theme.colors.background.primary};
`;

export const AgencyList = styled(ItemList)`
  display: flex;
  flex-wrap: wrap;
  flex: auto;
`;
